import { userApi as api, userSilentApi as silentApi } from "../../utils/apiInstances";

export const handleCreatePin = async (userData: unknown, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("POST", "/user/pin", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Forgot pin
export const handleForgot = async () => {
    try {
        const response = await silentApi("GET", "/user/forgot-pin");
        return response;
    } catch {
        return undefined;
    }
};

// set pin endpoint

export const handleResetPin = async (userData: unknown, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("POST", "/user/reset-pin", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
export const handleChangePin = async (userData: unknown, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("POST", "/user/change-pin", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
